import {
  GET_SERVICE,
  GET_SERVICE_SUCCESS,
  GET_SERVICE_FAIL,
  FLAG_SERVICE,
  FLAG_SERVICE_SUCCESS,
  FLAG_SERVICE_FAIL
} from '../constants/serviceManager';

const initialState = {
  services: [],
  error: null,
  loading: false,
  restarting: false,
}

export default (state = initialState, action) => {
  switch(action.type) {
    case GET_SERVICE:
      return {
        ...state,
        loading: true
      }
    case GET_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        services: action.data
      }
    case FLAG_SERVICE_FAIL:
    case GET_SERVICE_FAIL:
      return {
        ...state,
        loading: false,
        restarting: false,
        error: action.error
      }
    case FLAG_SERVICE:
      return {
        ...state,
        restarting: true
      }
    case FLAG_SERVICE_SUCCESS:
      return {
        ...state,
        restarting: false,
        services: state.services.map(service => service.pid === action.data.pid ? { ...service, flagged: true, lastUser: action.data.lastUser } : service)
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/serviceManager.js